import React from 'react';

import Box from '@mui/material/Box';

import Typography from 'src/components/ui/Typography';
import { colours } from 'src/constants/colours';
import Avatar from 'src/components/ui/Avatar';
import useAppRouter from 'src/hooks/useAppRouter';

import type { Company } from 'src/types/__generated__/graphql';
import { routePathCompany } from 'src/constants/router';
import { styledComponent } from 'src/utils/styled';

const StyledGroupAvatar = styledComponent(Avatar)`
    border-radius: 0.25rem;
`;

const StyledGroupLabel = styledComponent(Box)`
    background-color: ${colours.secondary.O08};
    display: flex;
    justify-content: center;
    padding: 0.125rem 0.5rem 0.125rem 0.125rem;
    height: 1.75rem;
    border-radius: 0.25rem;
    cursor: pointer;
    margin-bottom: 0.5rem;
`;

const StyledGroupTitleLabel = styledComponent(Typography)`
    font-weight: 400;
    font-size: 0.875rem;
    color: ${colours.secondary.main};
`;

interface Props {
    group: Company;
}

const GroupLabel: React.FC<Props> = ({ group }) => {
    const router = useAppRouter();
    return (
        <StyledGroupLabel
            data-target-id="companyHeader-groupLabel"
            onClick={() => router.push(`${routePathCompany}/${group.id}`)}
        >
            <StyledGroupAvatar
                isCompany={Boolean(group)}
                alt={group.name}
                image={group.image ?? undefined}
                fallbackText={group.initials}
                size={24}
            />
            <Box ml="0.5rem">
                <StyledGroupTitleLabel>{group.name}</StyledGroupTitleLabel>
            </Box>
        </StyledGroupLabel>
    );
};

export default GroupLabel;
